<template>
  <div class="flex-row config-indicator">
    <div class="trigger-border">
      <label>{{ $t('moagem-configuracao-para-gatilhos') }}</label>
      <span class="trigger-box img-width100">
        <img class="config-user" src="@/assets/ferramentas.png" alt="Editar configuração da moagem no turno"
          title="Editar configuração da moagem no turno" @click="() => openModalMilling()" />
      </span>
    </div>

    <b-modal id="modalTriggerMillingsSetting" :title="$t('moagem-configuracao-para-gatilhos')" hide-footer size="lg"
      :no-close-on-backdrop="true">
      <MillingsConfigsTriggerModal />
    </b-modal>
  </div>


</template>

<script>
import MillingsConfigsTriggerModal from "../millingSettingForTrigger/modalMillingsSetting.vue"

export default {
  name: "ConfigIndicator",
  props: ["dicIndicator", "selectIndicator", "indicatorConfiguration", "reset"],
  components: { MillingsConfigsTriggerModal },
  data() {
    return {
      confInd: {
        ref: 0,
        refDisabled: true,
        rangeDisabled: false,
        operationalRange: 0,
        criticalRange: 0,
        reabilityThreshold: 0,
        criticReabilityThreshold: 0
      },
      indConf: [],
    }
  },
  watch: {
    reset() {
      this.confInd.ref = 0,
        this.confInd.refDisabled = true,
        this.confInd.operationalRange = 0,
        this.confInd.criticalRange = 0,
        this.confInd.reabilityThreshold = 0,
        this.confInd.criticReabilityThreshold = 0
      this.confInd.rangeDisabled = false
    },

    selectIndicator(value) {
      if (typeof value != 'string' || !value) return
    },
  },
  methods: {
    loadIndicatorConfiguration() {
      this.indConf = this.indicatorConfiguration.find(ic => `${ic.indicatorId}-${ic.productionUnitId}-${ic.system}` == this.selectIndicator)
    },

    openModalMilling() {
      this.$bvModal.show("modalTriggerMillingsSetting");
    }
  },
}
</script>

<style scoped>
#operating-range,
#critical-range {
  width: 85px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
</style>

<style scoped src="../style.css"></style>